import { useFormContext } from 'react-hook-form';

import { SearchInput } from '@folio/components/features';
import type { SelectField } from 'korint-sdk/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function FormSearchableSelectInput({
  field,
  isLoading,
}: {
  field: SelectField;
  isLoading?: boolean;
}) {
  const { t } = useTranslation();

  const form = useFormContext();

  const searchKey = form.watch(field.name) as string | undefined;
  const [searchString, setSearchString] = useState('');

  const options = field.options.map(option =>
    typeof option === 'string'
      ? {
          label: t([`fields.${field.name}.options.${option}`, `options.${option}`, option]),
          value: option,
        }
      : option,
  );

  return (
    <SearchInput
      items={options.filter(({ label }) =>
        label.toUpperCase().includes(searchString.toUpperCase()),
      )}
      isLoading={isLoading ?? false}
      disabled={field.disabled}
      itemKey="value"
      onSelect={({ value }) => {
        form.setValue(field.name, value, {
          shouldDirty: true,
          shouldTouch: true,
        });
        setSearchString('');
      }}
      placeholder={field.DEPRECATED_placeholder ?? 'Rechercher'}
      search={searchString}
      renderItem={({ label }) => <div>{label}</div>}
      selected={options?.find(({ value }) => value === searchKey) ?? null}
      setSearch={value => {
        setSearchString(value);
      }}
    />
  );
}
